export const LISTE_REGIME_TVA = {
  title: 'Liste des régimes de TVA',
  breadcrumb: {
    liste: 'Liste des régimes de TVA',
  },
  actions: {
    add: 'Ajouter un régime de TVA',
  },
  filtres: {
    actif: {
      tilte: 'Actif',
      yes: 'Oui',
      no: 'Non',
    },
  },
  tab: {
    libelle: 'Libellé',
    tauxTva: 'Taux TVA',
    compteCentralisationClient: 'Compte de centralisation client',
    compteCentralisationFournisseur: 'Compte de centralisation fournisseur',
    cleComptable: 'Clé comptable',
    cleComptableToolTip: 'Remplacera le caractère "%" dans les comptes comptables de TVA',
    societe: 'Société',
    actif: 'Actif',
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce régime de TVA ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce régime de TVA ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Régime de TVA archivé avec succès',
    successDesarchivage: 'Régime de TVA désarchivé avec succès',
    error: {
      alreadyInAgency: 'Impossible d\'archiver un régime de tva qui est utilisé comme régime de TVA par défaut dans une agence',
    },
  },
};

export const ADD_REGIME_TVA = {
  titleAdd: 'Ajouter un régime de TVA',
  titleEdit: 'Modifier un régime de TVA',
  input: {
    libelle: 'Libellé',
    tauxTva: 'Taux de TVA',
    compteCentralisationClient: 'Compte de centralisation client',
    compteCentralisationFournisseur: 'Compte de centralisation fournisseur',
    cleComptable: 'Clé comptable',
    cleComptableToolTip: 'Remplacera le caractère % dans les compte comptables de TVA',
    actif: 'Actif',
  },
  error: {
    regimeTvaAlreadyExist: 'Le régime de TVA existe déja dans la société',
    tauxTva: 'Taux de TVA',
    regimeAlreadyExiste: 'Un régime de TVA identique existe déjà dans la société.',
    regimeAlreadyExisteInactif: 'Un régime de TVA identique mais inactif existe déjà dans la société.',
  },
  success: {
    add: 'Le régime de TVA a été ajouté avec succès.',
    edit: 'Le régime de TVA a été modifié avec succès.',
  },
};
